import { useLocation } from "react-router-dom";
import FillPatientDemographicsForm from "./FillPatientDemographicsForm"
import FillPatientInsuranceForm from "./FillPatientInsuranceForm"
import { useEffect, useState } from "react";
import { ServerRequestProtectedWithoutToken } from "../../../utils/ServerDataRequest";
import { enumUtil } from "../../../utils/Enum";
import ReleaseOfInformation from "./ReleaseOfInformation";
import CreditCardAuthorization from "./CreditCardAuthorization";

const SystemIntakes = () => {
    const API_URL = enumUtil.controller.Patient

    const location = useLocation();
    // Create a URLSearchParams instance using location.search
    const queryParams = new URLSearchParams(location.search);
    // Access specific query parameters
    const ID = queryParams.get('id');
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);

    const [GuidID, setGuidID] = useState(ID);
    const LoadData = (id) => {
        setIsLoading(true);
        setData([]);
        ServerRequestProtectedWithoutToken(API_URL + "/GetIntakeFileName", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientIntakeForm,
            "Value": id
        }).then((response) => {
            setData(response)
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
        })
    }
    useEffect(() => {
        if (ID) {
            setGuidID(ID)
            LoadData(ID);
        }
    }, [ID])
    return (
        <div>
            {data?.Data?.[0]?.FileName === "Patient Demographic.pdf" ?
                <FillPatientDemographicsForm ID={GuidID} PracticeInfo={data?.Practice[0] || {}} IsSubmitted={data?.Data[0]?.IsSubmitted || "False"}
                    isDeleted={data?.Data[0]?.IsDeleted || "false"} /> :
                data?.Data?.[0]?.FileName === "Patient Insurance.pdf" ?
                    <FillPatientInsuranceForm ID={GuidID} InsuranceDD={data?.Insurance} PracticeInfo={data?.Practice[0] || {}} PatientName={data?.Data[0]?.PatientName || ""}
                        IsSubmitted={data?.Data[0]?.IsSubmitted || "False"}
                        isDeleted={data?.Data[0]?.IsDeleted || "false"}
                        IsDefaultSignature={data?.Data[0]?.IsDefaultSignature}
                        SignaturePath={data?.Data[0]?.SignaturePath}
                    /> :
                    data?.Data?.[0]?.FileName === "Credit Card Authorization.pdf" ?
                        <CreditCardAuthorization
                            ID={GuidID}
                            InsuranceDD={data?.Insurance}
                            PracticeInfo={data?.Practice[0] || {}}
                            PatientName={data?.Data[0]?.PatientName || ""}
                            data={data?.Data[0]?.paymentGateWayTokenizerURL}
                            PatientID={data?.Data[0]?.PatientID || ""}
                            IsSubmitted={data?.Data[0]?.IsSubmitted || "False"}
                            IsDefaultSignature={data?.Data[0]?.IsDefaultSignature}
                            DefaultSignaturePath={data?.Data[0]?.SignaturePath}
                            isDeleted={data?.Data[0]?.IsDeleted || "false"} /> :
                        data?.Data?.[0]?.FileName === "Release Of Information Form.pdf" ?
                            <ReleaseOfInformation
                                ID={GuidID}
                                InsuranceDD={data?.Insurance}
                                PracticeInfo={data?.Practice[0] || {}}
                                PatientName={data?.Data[0]?.PatientName || ""}
                                IsDefaultSignature={data?.Data[0]?.IsDefaultSignature}
                                DefaultSignaturePath={data?.Data[0]?.SignaturePath}
                                IsSubmitted={data?.Data[0]?.IsSubmitted || "False"}
                                isDeleted={data?.Data[0]?.IsDeleted || "false"}
                            /> : null
            }
        </div>
    )
}

export default SystemIntakes